import { GenericObject } from '../../utils/GenericObject';
import { userReducer } from './user/user-reducer';
import { AnyAction } from '../AnyAction';
import { User } from '../../domain/User/User';
import { storeReducer } from './store/store-reducer';
import { languageReducer } from './store/language-reducer';
// import { languageReducer } from './store/language-reducer';

export interface CurrentUser {
  user?: User;
  isPending: boolean;
  error?: GenericObject;
}

export interface GlobalState {
  currentUser: CurrentUser;
  updatedStoreNumber: string;
  language: string;
}

export const initialState: GlobalState = {
  currentUser: {
    isPending: false,
  },
  updatedStoreNumber: '',
  language: '',
};

export const globalReducer = (
  state: GlobalState,
  action: AnyAction
): GlobalState => {
  const { currentUser, updatedStoreNumber } = state;

  return {
    currentUser: userReducer(currentUser, action),
    updatedStoreNumber: storeReducer(updatedStoreNumber, action),
    language: languageReducer(state.language, action),
  };
};
